import { getCampaignTimeseries as getCampaignTimeSeries } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetCampaignTimeSeries = (
    { campaignId, type = 'Send', scale = '_1h', start, end },
    enabled
) =>
    useQuery({
        queryKey: [
            'campaign_timeseries',
            campaignId,
            type,
            scale,
            `${start}-${end}`,
        ],
        queryFn: async () =>
            getCampaignTimeSeries({
                id: campaignId,
                type,
                scale,
                start,
                end,
            }),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetCampaignTimeSeries;
